<template>
  <div>
    <div class="sf-grid">
      <div>
        <div
          class="sf-level sf-level-center sf-below-3"
          data-walkthrough-id="communications-groups"
        >
          <div class="sf-btn-bar sf-btn-bar-primary">
            <a
              :class="[
                'sf-btn sf-btn-bar-item',
                filter === 'all' ? 'sf-btn-active' : '',
              ]"
              @click.prevent="changeFilter('all')"
            >
              {{ I18n.t('communication.grouped.filter.all') }}
            </a>
            <a
              :class="[
                'sf-btn sf-btn-bar-item',
                filter === 'todos' ? 'sf-btn-active' : '',
              ]"
              @click.prevent="changeFilter('todos')"
            >
              {{ I18n.t('communication.grouped.filter.todos') }}
            </a>
            <a
              :class="[
                'sf-btn sf-btn-bar-item',
                filter === 'following' ? 'sf-btn-active' : '',
              ]"
              @click.prevent="changeFilter('following')"
              >{{ I18n.t('communication.grouped.filter.following') }}</a
            >
          </div>
        </div>
        <template v-if="fetchingCommunicationsInProgress">
          <div class="sf-align-c">
            <div class="sf-spinner sf-inline-block"></div>
          </div>
        </template>
        <template v-else
          ><div v-if="isEmpty" class="sf-row sf-row-center">
            <div class="sf-col">
              <div class="sf-empty-state">
                <img
                  :src="$imagesRequire('empty_states/communication.svg')"
                  class="sf-empty-state-image"
                />
                <div class="sf-empty-state-title">
                  {{ I18n.t('communication.empty_state.title') }}
                </div>
                <div class="sf-c-text">
                  {{ I18n.t('communication.empty_state.message') }}
                </div>
              </div>
            </div>
          </div>
          <div v-else class="sf-row sf-row-center sf-below-4">
            <div class="sf-col sf-sm-8">
              <context-remarks
                v-for="context in sortedContexts"
                :key="context.id"
                :filter="filter"
                v-bind="context"
              ></context-remarks>
            </div></div
        ></template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import { mapActions, mapState, mapGetters } from 'vuex'

import scrollHelper from './mixins/scroll-helper'

import ContextRemarks from './contexts/context-remarks'

const GroupedCommunication = {
  components: {
    ContextRemarks,
  },

  mixins: [scrollHelper],

  data() {
    return {
      filter: 'all',
      anchorElementScrolled: false,
    }
  },

  computed: {
    ...mapGetters(['fetchingCommunicationsInProgress']),
    ...mapState({
      contexts: (state) => state.contexts.contexts,
      ledgerId: (state) => state.ledgerId,
    }),

    sortedContexts() {
      // Confirm with product before you modify the order of these items
      // it controls the product-defined order of these contexts/groups of remarks in the UI.
      // Keep in sync with CommunicationsContextHelper::caption_for_context
      const sortedContextNames = [
        'Company',
        'ReconciliationText',
        'Account',
        'Report::Template',
        'BudgetSet',
        'Document',
        'CompanyWorkflowStatus',
      ]
      const sortedContexts = []

      if (this.contexts[this.ledgerId]) {
        sortedContextNames.forEach((contextName) => {
          _.orderBy(
            this.contexts[this.ledgerId][contextName],
            ['caption'],
            ['asc']
          ).forEach((context) => {
            sortedContexts.push(context)
          })
        })
      }

      return sortedContexts
    },

    isEmpty() {
      return this.sortedContexts.length === 0
    },
  },

  created() {
    this.fetchCommunication()
    this.fetchNotificationsForCompany()
    this.fetchMentionUsernames()
    // Event handlers
    window.eventHub.$on('refreshCommunicationData', this.fetchCommunication)
    window.eventHub.$on(
      'refreshCommunicationData',
      this.fetchNotificationsForCompany
    )
    window.eventHub.$on('resetCommunicationData', this.resetCommunicationData)
  },

  beforeUnmount() {
    window.eventHub.$off('refreshCommunicationData', this.fetchCommunication)
    window.eventHub.$on(
      'refreshCommunicationData',
      this.fetchNotificationsForCompany
    )
    window.eventHub.$off('resetCommunicationData', this.resetCommunicationData)
  },

  methods: {
    ...mapActions([
      'fetchCommunication',
      'fetchMentionUsernames',
      'fetchNotifications',
      'resetCommunicationData',
    ]),

    fetchNotificationsForCompany() {
      this.fetchNotifications(Silverfin.currentCompanyId)
    },

    changeFilter(type) {
      this.filter = type
    },

    handleAnchorScroll() {
      this.scrollTo(this.elementAnchorLink()).then(() => {
        this.anchorElementScrolled = true
      })
    },
  },
}

export default GroupedCommunication
</script>
